//CustomEvent constructor polyfill https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
(function () {
    if (typeof window.CustomEvent === 'function') return false; //If not IE

    function CustomEvent(event, params) {
        params = params || {bubbles: false, cancelable: false, detail: undefined};
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }

    CustomEvent.prototype = window.Event.prototype;

    window.CustomEvent = CustomEvent;
})();

// Helper function to check if an element is visible
function isVisible(element) {
    return element && !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
}

function slideUp(target, duration = 0) {
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.boxSizing = 'border-box';
    target.style.height = target.offsetHeight + 'px';

    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.style.overflow = 'hidden';

    window.setTimeout(() => {
        target.style.display = 'none';
        target.style.removeProperty('height');
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
    }, duration);
}

function slideDown(target, duration = 0) {
    target.style.removeProperty('display');
    let display = window.getComputedStyle(target).display;
    if (display === 'none') {
        display = 'block';
    }
    target.style.display = display;

    let height = target.offsetHeight;
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.style.overflow = 'hidden';

    target.style.boxSizing = 'border-box';
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.height = height + 'px';
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');

    window.setTimeout(() => {
        target.style.removeProperty('height');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
    }, duration);
}

function slideToggle(target, duration) {
    if (window.getComputedStyle(target).display === 'none') {
        return slideDown(target, duration);
    } else {
        return slideUp(target, duration);
    }
}

function loadEmail({floorplanId, communityName, floorplanName = null, commentPlaceholder}) {
    $('#emailMissingInput').hide();
    $('#emailError').hide();
    $('#emailCommunityNameBanner').html(unescape(communityName));
    $('#emailCommunityName').val(unescapeHtml(communityName));
    if (floorplanName != null) {
        $('#emailFloorplanName').val(unescapeHtml(floorplanName));
        $('#emailFloorplan').val(floorplanId);
        $('#emailSelectFloorplanWrapper').hide();
    } else {
        $('#emailCommunity').val(floorplanId);
        $('#emailSelectFloorplanWrapper').show();
    }
    $('#emailLoader').hide();
    if ($('#emailComments').val() == '') {
        $('#emailComments').val(commentPlaceholder);
    }
    // if the form is using reCAPTCHA we want to make sure we reset this when the popup loads
    if (typeof reCaptchaWidgets !== 'undefined' && reCaptchaWidgets['email-popup-recaptcha'] != null) {
        grecaptcha.enterprise.reset(reCaptchaWidgets['email-popup-recaptcha']);
    }
}

function autoCorrectPhone(event, phoneField) {
    if (event.charCode > 0) {
        var phoneCharacters = (phoneField.value + String.fromCharCode(event.charCode)).split('');
        var newPhoneValue = '';
        for (var i = 0; i < phoneCharacters.length; i++) {
            if (i == 0 && !(phoneCharacters.length == 1 && phoneCharacters[i] == '(')) {
                newPhoneValue += '(';
            } else if (i == 4 && !(phoneCharacters.length == 5 && phoneCharacters[i] == ')')) {
                newPhoneValue += ')';
            } else if (i == 5 && !(phoneCharacters.length == 6 && phoneCharacters[i] == ' ')) {
                newPhoneValue += ' ';
            } else if (i == 9 && !(phoneCharacters.length == 10 && phoneCharacters[i] == '-')) {
                newPhoneValue += '-';
            }
            if ($.isNumeric(phoneCharacters[i]) && i != (phoneCharacters.length - 1)) {
                newPhoneValue += phoneCharacters[i];
            }
        }
        phoneField.value = newPhoneValue;
    }
}

function unescapeHtml(unsafe) {
    return unescape(unsafe)
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&#039;/g, '\'')
        .replace(/&#39;/g, '\'');
}

function clickOnEnterKeyPress(event, currentElement) {
    var keycode = (event.keyCode ? event.keyCode : event.which);
    if (keycode == 13) {            // check for enter key (13)
        $(currentElement).click();  // fire the click event
        event.preventDefault();
    }
    return false;
}

function handleEnterKeyPress(event, element, triggerOnClick, shouldPreventDefault, shouldStopPropagation) {
    const keycode = (event.keyCode ? event.keyCode : event.which);
    if (keycode === 13) {           // check for enter key (13)
        if (triggerOnClick) {
            $(element).click();     // fire the click event
        }
        if (shouldPreventDefault) {
            event.preventDefault();
        }
        if (shouldStopPropagation) {
            event.stopPropagation();
        }
    }
    return false;
}

let formErrors = [];

function sendEmail(submitButton, isNotPopup = false, isFloorplanRequired = false, reCaptchaRequired = false) {
    $(submitButton).prop('disabled', true);
    const name = $('#emailName');
    const email = $('#emailEmail');
    const phone = $('#emailPhone');
    const moveInDate = $('#emailMoveInDate');
    const privacyPolicyAgreement = $('#agreeToPrivacyPolicy');
    const consentAgreement = $('#agreeToConsent');
    const hasAdditionalConsent = consentAgreement.length > 0;
    let focusInput = null;

    if (formErrors.length > 0) {
        // If there are unfixed errors in the list clear the list, and refill.
        // this is to prevent the same error occurring multiple times in the list
        // this also ensures that the first error in the list is the first error on the page
        formErrors[0].hide();
        formErrors = [];
    }
    if (!validNameInput(name)) {
        formErrors.push($('#emailNameErrorMessage'));
        if (focusInput === null) {
            focusInput = name;
        }
        name.addClass('inputError');
    } else {
        name.removeClass('inputError');
    }
    if (!validEmailInput(email)) {
        formErrors.push($('#emailEmailErrorMessage'));
        if (focusInput === null) {
            focusInput = email;
        }
        email.addClass('inputError');
    } else {
        email.removeClass('inputError');
    }
    if (!validPhoneInput(phone)) {
        formErrors.push($('#emailPhoneErrorMessage'));
        if (focusInput === null) {
            focusInput = phone;
        }
        phone.addClass('inputError');
    } else {
        phone.removeClass('inputError');
    }

    if (!validDateMMDDYYYY(moveInDate, true)) {
        formErrors.push($('#emailMoveInDateErrorMessage'));
        if (focusInput === null) {
            focusInput = moveInDate;
        }
        moveInDate.addClass('inputError');
    } else {
        moveInDate.removeClass('inputError');
    }

    const {
        floorplan,
        floorplanName,
        floorplanInput,
        isFloorplanValid,
    } = validateAndExtractFloorplan(isFloorplanRequired);

    if (focusInput === null && !isFloorplanValid) {
        focusInput = floorplanInput;
    }

    if (!privacyPolicyAgreement.prop('checked')) {
        formErrors.push($('#agreeToPrivacyPolicyErrorMessage'));
        if (focusInput === null) {
            focusInput = privacyPolicyAgreement;
        }
        privacyPolicyAgreement.siblings()[0].classList.add('inputError');
    } else {
        privacyPolicyAgreement.siblings()[0].classList.remove('inputError');
    }

    let reCaptchaWidgetId = null;
    let reCaptchaToken = null;
    if (reCaptchaRequired) {
        reCaptchaWidgetId = isNotPopup ? 'contact-form-recaptcha' : 'email-popup-recaptcha';
        reCaptchaToken = grecaptcha.enterprise.getResponse(reCaptchaWidgets[reCaptchaWidgetId]);
        if (reCaptchaToken === '') {
            formErrors.push($('#' + reCaptchaWidgetId + 'ErrorMessage'));
            document.getElementById(reCaptchaWidgetId).classList.add('inputError');
        } else {
            document.getElementById(reCaptchaWidgetId).classList.remove('inputError');
        }
    }

    if (formErrors.length > 0) {
        formErrors[0].show();
        if (focusInput !== null) {
            focusInput.focus();
        }
        $(submitButton).prop('disabled', false);
        return false;
    }

    $('#emailError').hide();
    var json = new Object();
    json['n'] = $('#emailName').val();
    json['e'] = $('#emailEmail').val();
    json['p'] = $.trim($('#emailPhone').val());
    json['mi'] = $('#emailMoveInDate').val();
    json['c'] = $('#emailComments').val();
    if (floorplan) {
        json['f'] = floorplan;
        if (floorplanName) {
            json['fpn'] = floorplanName;
        }
    } else {
        json['ci'] = $('#emailCommunity').val();
    }
    json['cn'] = $('#emailCommunityName').val();
    if (hasAdditionalConsent) {
        // see ADDITIONAL_CONSENT in ContactPropertyManagerEmail.java
        json['ac'] = consentAgreement.prop('checked') ? 'Yes' : 'No';
    }
    json['guid'] = $('#emailGuid').val();
    json['cap'] = $('#emailCaptchaEntry').val();
    json['cs'] = $('#emailCaptchaSession').val();
    json['u'] = $(location).attr('href');
    json['ks'] = getLocalStorageItemByPrefix('knock-source');
    json['ills'] = $('#emailSource').val();

    if (reCaptchaRequired && reCaptchaToken) {
        json['reCaptchaToken'] = reCaptchaToken;
    }

    $('#emailLoader').show();
    var request = $.ajax({
        url: '/rapi/server/email/contact-property',
        type: 'POST',
        data: json,
    });
    request.done(function (msg) {
        $('#emailLoader').hide();
        $(submitButton).prop('disabled', false);
        if (msg['m'] != null) {
            if (isNotPopup) {
                magnificGenerator('<h3>Error</h3><p>' + msg['m'] + '</p>', 'error', 'Continue');
            } else {
                $('#emailError').html(msg['m']);
                $('#emailError').show();
            }
        } else {
            $('#emailError').hide();
            $('#emailName').val('');
            $('#emailEmail').val('');
            $('#emailPhone').val('');
            $('#emailMoveInDate').val('');
            $('#emailSelectFloorplan').val('');
            $('#emailSelectFloorplan').removeClass(SELECT_HAS_VALUE);
            $('#emailSelectFloorplanWrapper').hide();
            $('#emailComments').val('');
            privacyPolicyAgreement.prop('checked', false);
            if (hasAdditionalConsent) {
                consentAgreement.prop('checked', false);
            }
            if (isNotPopup) {
                magnificGenerator('<h3>Success</h3><p>Email sent. Thank you!</p>', 'success', 'Continue');
            } else {
                try {
                    $.magnificPopup.close();
                } catch (err) {
                    //Nothing
                }
                magnificGenerator('<h3>Success</h3><p>Email sent. Thank you!</p>', 'success', 'Continue');
            }
            if ($('#emailFloorplan').length) {
                trackEvent('Send Email', 'Floorplan', $('#emailFloorplan').val());
            } else {
                trackEvent('Send Email', 'Community', $('#emailCommunity').val());
            }
        }
        if (reCaptchaRequired) {
            grecaptcha.enterprise.reset(reCaptchaWidgets[reCaptchaWidgetId]);
        }
    });
    request.fail(function (jqXHR, textStatus) {
        $('#emailLoader').hide();
        if (isNotPopup) {
            magnificGenerator('<h3>Error</h3><p>We were unable to send the email, please try again.</p>', 'error', 'Continue');
        } else {
            $('#emailError').html('We were unable to send the email, please try again.');
            $('#emailError').show();
        }
        $(submitButton).prop('disabled', false);
        if (reCaptchaRequired) {
            grecaptcha.enterprise.reset(reCaptchaWidgets[reCaptchaWidgetId]);
        }
    });
}

function validateAndExtractFloorplan(isFloorplanRequired) {
    let floorplan;
    let floorplanName;
    let floorplanInput;
    let isFloorplanValid = true;
    if ($('#emailFloorplan').length && $('#emailFloorplan').val().length > 0) {
        floorplanInput = $('#emailFloorplan');
        floorplan = floorplanInput.val();
        floorplanName = $('#emailFloorplanName').val();
    } else if ($('#emailSelectFloorplan').length) {
        floorplanInput = $('#emailSelectFloorplan');
        //We need the floorplanInput for the required piece below, but we don't want to set the floorplan value unless there is data.
        if ($('#emailSelectFloorplan').val().length > 0) {
            floorplan = floorplanInput.val();
        }
    }
    if (isFloorplanRequired && $.trim(floorplan).length === 0) {
        $('#emailSelectFloorplanErrorMessage').html('Please select a Floorplan');
        formErrors.push($('#emailSelectFloorplanErrorMessage'));
        isFloorplanValid = false;
        floorplanInput.addClass('inputError');
    } else {
        floorplanInput.removeClass('inputError');
    }

    return {
        floorplan,
        floorplanName,
        floorplanInput,
        isFloorplanValid,
    };
}

// Get the exact match for a local storage item OR a prefix match if exact match does not exist.
function getLocalStorageItemByPrefix(itemName) {
    var fuzzyMatchKey = null;
    for (var i = 0; i < localStorage.length; i++) {
        var tempKey = localStorage.key(i);
        if (tempKey === itemName) {
            return localStorage.getItem(itemName);
        } else if (tempKey.startsWith(itemName)) {
            fuzzyMatchKey = tempKey;
        }
    }
    return fuzzyMatchKey == null ? null : localStorage.getItem(fuzzyMatchKey);
}

function validateFormField(formFieldElement, validationType) {
    let formFieldValid = false;
    const formField = $(formFieldElement);
    if (formField !== null) {
        if (validationType === 'text') {
            formFieldValid = validTextInput(formField);
        } else if (validationType === 'name') {
            formFieldValid = validNameInput(formField);
        } else if (validationType === 'email') {
            formFieldValid = validEmailInput(formField);
        } else if (validationType === 'phone') {
            formFieldValid = validPhoneInput(formField);
        } else if (validationType === 'dateWithoutPastDates') {
            formFieldValid = validDateMMDDYYYY(formField, true);
        } else if (validationType === 'dateWithPastDates') {
            formFieldValid = validDateMMDDYYYY(formField, false);
        } else if (validationType === 'checkbox') {
            formFieldValid = formField.prop('checked');
        } else if (validationType === 'requiredSelect') {
            formFieldValid = !!formField.val();
        } else if (validationType === 'reCaptcha') {
            formFieldValid = grecaptcha.enterprise.getResponse(reCaptchaWidgets[formFieldElement.id]) !== '';
        }
        if (formFieldValid) {
            if (validationType === 'checkbox') {
                formField.siblings()[0].classList.remove('inputError');
            } else {
                formField.removeClass('inputError');
            }
            if ($('#' + formField.attr('id') + 'ErrorMessage').is(':visible')) { // If the current form field's error message is visible, clear the current error message and display the next one
                let currentErrorMessage = formErrors.shift();
                currentErrorMessage.hide();
                if (formErrors.length > 0) {
                    formErrors[0].show();
                }
            } else { // Else if the current form field's error message is not visible, find and remove its error message from the list
                for (let i = 0; i < formErrors.length; i++) {
                    if (formErrors[i].attr('id') === formField.attr('id') + 'ErrorMessage') {
                        formErrors.splice(i, 1);
                        break;
                    }
                }
            }
        }
    }
}

function validTextInput(textInput) {
    if ($.trim(textInput.val()).length === 0) {
        $('#' + textInput.attr('id') + 'ErrorMessage').html('This field is required');
        return false;
    }
    return true;
}

function validNameInput(nameInput) {
    if ($.trim(nameInput.val()).length === 0) {
        $('#' + nameInput.attr('id') + 'ErrorMessage').html('Please enter your name');
        return false;
    }
    return true;
}

function validEmailInput(emailInput) {
    const email = $.trim(emailInput.val());
    if (emailInput.hasClass('required') && email.length === 0) {
        $('#' + emailInput.attr('id') + 'ErrorMessage').html('Please enter your email');
        return false;
    }
    if (email.length > 0) {
        // email syntax regex
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!re.test(email) || /.con$/i.test(email)) {
            $('#' + emailInput.attr('id') + 'ErrorMessage').html('Please enter a valid email');
            return false;
        }
    }
    return true;
}

function validPhoneInput(phoneNumberInput) {
    const phoneNumber = $.trim(phoneNumberInput.val());
    let validPhone = false;
    if (phoneNumberInput.hasClass('required') && phoneNumber.length === 0) {
        $('#' + phoneNumberInput.attr('id') + 'ErrorMessage').html('Please enter your phone number');
        return false;
    } else if (phoneNumber.length === 0) {
        return true;
    }
    if (phoneNumber.length == 14) {
        if (phoneNumber.charAt(0) == '(' && phoneNumber.charAt(4) == ')' && phoneNumber.charAt(5) == ' ' && phoneNumber.charAt(9) == '-') {
            var phoneString = phoneNumber.substring(1, 4) + '' + phoneNumber.substring(6, 9) + phoneNumber.substring(10, 14);
            if (parseInt(phoneString).toString() == phoneString) {
                validPhone = true;
            }
        }
    }
    if (!validPhone) {
        $('#' + phoneNumberInput.attr('id') + 'ErrorMessage').html('Please enter a valid phone number');
    }
    return validPhone;
}

function submitResidentsForm(contentId, api) {
    $('#submit_' + contentId).prop('disabled', true);
    var inputs = $('#form_' + contentId).find('input, textarea, select');
    const privacyPolicyAgreement = $('#agreeToPrivacyPolicy' + contentId);
    var json = new Object();
    let focusInput = null;

    if (formErrors.length > 0) {
        // If there are unfixed errors in the list clear the list, and refill.
        // this is to prevent the same error occuring multiple times in the list
        // this also ensures that the first error in the list is the first error on the page
        formErrors[0].hide();
        formErrors = [];
    }

    for (var i = 0; i < inputs.length; i++) {
        var input = $(inputs[i]);
        if ($(input).hasClass('required') && input.hasClass('validateText') && !validTextInput(input)) {
            formErrors.push($('#' + input.attr('id') + 'ErrorMessage'));
            if (focusInput === null) {
                focusInput = input;
            }
            input.addClass('inputError');
        } else if (input.hasClass('validateEmail') && !validEmailInput(input)) {
            formErrors.push($('#' + input.attr('id') + 'ErrorMessage'));
            if (focusInput === null) {
                focusInput = input;
            }
            input.addClass('inputError');
        } else if (input.hasClass('validateDate') && !validDateMMDDYYYY(input, false)) {
            formErrors.push($('#' + input.attr('id') + 'ErrorMessage'));
            if (focusInput === null) {
                focusInput = input;
            }
            input.addClass('inputError');
        } else {
            input.removeClass('inputError');
        }
        json[input.attr('name')] = input.val();
    }

    if (!privacyPolicyAgreement.prop('checked')) {
        formErrors.push($('#agreeToPrivacyPolicy' + contentId + 'ErrorMessage'));
        if (focusInput === null) {
            focusInput = privacyPolicyAgreement;
        }
        privacyPolicyAgreement.siblings()[0].classList.add('inputError');
    } else {
        privacyPolicyAgreement.siblings()[0].classList.remove('inputError');
    }

    if (formErrors.length > 0) {
        formErrors[0].show();
        if (focusInput !== null) {
            focusInput.focus();
        }
        $('#submit_' + contentId).prop('disabled', false);
        return false;
    }

    json['u'] = $(location).attr('href');
    for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].type == 'hidden') {
            if (inputs[i].name == 'guid') {
                json['guid'] = $(inputs[i]).val();
            } else if (inputs[i].name == 'ills') {
                json['ills'] = $(inputs[i]).val();
            }
        }
    }
    json['ks'] = getLocalStorageItemByPrefix('knock-source');
    $('#submit_' + contentId + ' .form-submit-animation').show();
    var request = $.ajax({
        url: '/rapi/server/email/' + api,
        type: 'POST',
        data: json,
    });
    request.done(function (msg) {
        for (var i = 0; i < inputs.length; i++) {
            if (inputs[i].type != 'hidden') {
                $(inputs[i]).val('');
            }
        }
        magnificGenerator('<h3>Success</h3><p>Email sent. Thank you!</p>', 'success', 'Continue');
        $('#submit_' + contentId + ' .form-submit-animation').hide();
        $('#submit_' + contentId).prop('disabled', false);
        privacyPolicyAgreement.prop('checked', false);
    });
    request.fail(function (jqXHR, textStatus) {
        if (jqXHR.responseJSON && jqXHR.responseJSON.message) { // make sure there is a response json and that it has a message
            magnificGenerator('<h3>Error</h3><p>' + jqXHR.responseJSON.message + '</p>', 'error', 'Continue');
        } else {
            magnificGenerator('<h3>Error</h3><p>We were unable to send the email, please try again.</p>', 'error', 'Continue');
        }
        $('#submit_' + contentId + ' .form-submit-animation').hide();
        $('#submit_' + contentId).prop('disabled', false);
        privacyPolicyAgreement.prop('checked', false);
    });
    return false;
}

function magnific(text, input) {
    magnificGenerator(text, null, null, input);
}

/**
 * Types available: success, error
 */
function magnificGenerator(text, type, closeButtonText, input) {
    $.magnificPopup.open({
        items: {
            src: '<div class="white-popup' + (type !== null ? (' white-' + type + '-popup') : '') + '">'
                + (type !== null ? '<div class="header-icon"><img src="/assets/images/community/version2/' + type + '.svg" alt=""/></div>' : '')
                + text
                + (closeButtonText !== null ? '<div class="submitBanner"><a class="solidButton" href="#" onclick="$.magnificPopup.close();return false;">' + closeButtonText + '</a></div>' : '')
                + '</div>'
        },
        type: 'inline',
        callbacks: {
            afterClose: function () {
                if (input != null) {
                    $(input).focus();
                    $(input).parent().addClass('error');
                    window.scroll(0, $(input).offset().top - 25);
                }
            }
        }
    }, 0);
}

function submitApplyForm(contentId) {
    $('#submit_' + contentId).prop('disabled', true);
    var inputs = $('#form_' + contentId).find('input, textarea, select');
    const privacyPolicyAgreement = $('#agreeToPrivacyPolicy');
    var json = new Object();
    let focusInput = null;

    if (formErrors.length > 0) {
        // If there are unfixed errors in the list clear the list, and refill.
        // this is to prevent the same error occuring multiple times in the list
        // this also ensures that the first error in the list is the first error on the page
        formErrors[0].hide();
        formErrors = [];
    }

    for (var i = 0; i < inputs.length; i++) {
        var input = $(inputs[i]);
        if (input.hasClass('required') && input.hasClass('validateText') && !validTextInput(input)) {
            formErrors.push($('#' + input.attr('id') + 'ErrorMessage'));
            if (focusInput === null) {
                focusInput = input;
            }
            input.addClass('inputError');
        } else if (input.hasClass('validateEmail') && !validEmailInput(input)) {
            formErrors.push($('#' + input.attr('id') + 'ErrorMessage'));
            if (focusInput === null) {
                focusInput = input;
            }
            input.addClass('inputError');
        } else if (input.hasClass('validateDate') && !validDateMMDDYYYY(input, false)) {
            formErrors.push($('#' + input.attr('id') + 'ErrorMessage'));
            if (focusInput === null) {
                focusInput = input;
            }
            input.addClass('inputError');
        } else {
            input.removeClass('inputError');
        }
        json[input.attr('name')] = input.val();
    }

    if (!privacyPolicyAgreement.prop('checked')) {
        formErrors.push($('#agreeToPrivacyPolicyErrorMessage'));
        if (focusInput === null) {
            focusInput = privacyPolicyAgreement;
        }
        privacyPolicyAgreement.siblings()[0].classList.add('inputError');
    } else {
        privacyPolicyAgreement.siblings()[0].classList.remove('inputError');
    }

    if (formErrors.length > 0) {
        formErrors[0].show();
        if (focusInput !== null) {
            focusInput.focus();
        }
        $('#submit_' + contentId).prop('disabled', false);
        return false;
    }

    $('#submit_' + contentId + ' .form-submit-animation').show();
    privacyPolicyAgreement.prop('checked', false);
    return true;
}

function trackLinkClickLabelWithURL(category, action) {
    var relativeURLLabel = window.location.pathname;
    trackEvent(category, action, relativeURLLabel);
}

function trackFloorplanEntry(link, floorplanId) {
    trackEvent('Floorplan Entry', link, floorplanId);
}

function trackFeaturedFloorplanClick(position) {
    trackGA4Event(`featured_floorplan_${position}`);
}

function trackOtherCommunityExit(link, communityId) {
    trackEvent('Other Community Exit', link, communityId);
}

function trackEvent(category, action, label) {
    // visit_data_tracking (internal)
    try {
        const data = setVisitData(); // Internal tracking
        submitVisitData(data, category);
    } catch (err) {
        logAnalyticsError(err);
    }

    if (category === 'engaged_visit') {
        // GA4 (external)
        trackGA4Event(category, {
            first_page: sessionStorage.getItem(SESSION_STORAGE_LAST_VALID_PAGE),
            conversion_page: window.location.pathname,
        });
    } else if (category === 'highly_engaged_visit') {
        // GA4 (external)
        trackGA4Event(category, {
            first_page: sessionStorage.getItem(SESSION_STORAGE_HEV_FIRST_PAGE),
            conversion_page: window.location.pathname,
        });
    }

    if (['Send Email', 'Lead'].includes(category)) {
        try {
            fbq('track', 'Lead');
        } catch (err) {
            //ignore
        }
    }
    if (['Send Email', 'Lead', 'Prospect'].includes(category)) {
        trackEngagedAction(2);
    }
    if (category === 'Video Play') {
        trackGA4Event('video_play', {
            content_id: `f_${label}` //need to pass strings, not numbers for GA4 to process the event.
        });
        trackEngagedAction(1);
    }
}

function trackGA4Event(eventType, parameters = {}) {
    try {
        gtag('event', eventType, parameters);
    } catch (err) {
        logAnalyticsError(err);
    }
}

function triggerPlayerStartedEvent(playerId) {
    window.dispatchEvent(new CustomEvent(
        'video-player-started',
        {
            detail: {
                playerId: playerId
            }
        })
    );
}

var playerStart = new Array();

function onPlayerStateChange(event) {
    var playerId = event.target.getIframe().id.substring('player'.length);
    if (event.data == YT.PlayerState.PLAYING && playerStart[playerId] != true) {
        trackEvent('Video Play', location.pathname, playerId);
        playerStart[playerId] = true;
        triggerPlayerStartedEvent(playerId);
    }
}

function wistiaPlay(playerId) {
    if (playerStart[playerId] != true) {
        trackEvent('Video Play', location.pathname, playerId);
        playerStart[playerId] = true;
        triggerPlayerStartedEvent(playerId);
    }
}

function isMobileDevice() {
    return (/Android|iPhone|iPad|iPod|BlackBerry/i).test(navigator.userAgent || navigator.vendor || window.opera);
}

function isMobilePage() {
    var body = document.getElementsByTagName('body')[0];
    return body.classList.contains('mobile-page');
}

var SELECT_WRAPPER_CLASS = 'rentpingSelectWrapper',
    SELECT_HAS_VALUE = 'hasValue';

function wrapElements(elements, wrappingElement) {
    Array.prototype.forEach.call(elements, function (element) {
        wrappingElement.appendChild(element);
    });
}

function wrapSelect(element) {
    var parentEl = element.parentNode,
        isWrapped = parentEl.classList.contains(SELECT_WRAPPER_CLASS);

    if (!isWrapped) {
        //According to https://developer.mozilla.org/en-US/docs/Web/API/Document/createDocumentFragment this will use memory instead of causing a bunch of html reflows.
        var fragment = document.createDocumentFragment(),
            selectWrapper = document.createElement('div'),
            selectStyler = document.createElement('div'),
            selectEls = Array.from(parentEl.childNodes);

        selectWrapper.classList.add(SELECT_WRAPPER_CLASS);
        selectStyler.classList.add('select-wrapper');
        fragment.appendChild(selectWrapper);
        selectEls.push(selectStyler);

        wrapElements(selectEls, selectWrapper);
        wrapElements([selectWrapper], parentEl);


        selectStyler.appendChild(element);
        $('#' + element.id + 'Label').appendTo(selectStyler);
    }
}

function wrapSelects(parentElement) {
    var selects = parentElement.querySelectorAll('select');
    Array.prototype.forEach.call(selects, wrapSelect);

    return selects;
}

function setupSelectListener(select) {
    select.addEventListener('change', function () {
        var val = select.value;

        //This may need to be updated as we run into more cases.
        if (!!val && val !== '-1') {
            select.classList.add(SELECT_HAS_VALUE);
        } else {
            select.classList.remove(SELECT_HAS_VALUE);
        }
    });
}

function initSelects() {
    var selects = wrapSelects(document);
    Array.prototype.forEach.call(selects, setupSelectListener);
}

function popupSetSpecialTermsWidth(popupItem) {							// function called after the Specials popup initially renders - it will be called, via a popup callback, after the popup has been opened

    var $terms = $(popupItem + ' .special-popup-terms');
    if ($terms.length) {
        $terms.width($(popupItem + ' .special-popup-content').width());    	// set the width of the special terms element so that it matches the width of the special
        if (!($terms.get(0).clientHeight < $terms.get(0).scrollHeight)) {   // if terms are not overflowing the container, then set a class that will remove the top and bottom fade effects for the terms in the scollbox
            $terms.addClass('no-fade');
        }
    }
}

var areasToCheckForKeyboardingArray = [];

function monitorAreaForKeyboardNavigation(elementId) {
    areasToCheckForKeyboardingArray.push(elementId);
}

document.addEventListener('DOMContentLoaded', function () {
    jQuery(function ($) {
        $('.open-popup-link').magnificPopup({
            type: 'inline',
            midClick: true,
            closeBtnInside: true
        });

        $('.open-popup-link-with-callbacks').each(function () {
            $(this).magnificPopup({
                type: 'inline',
                midClick: true,
                closeBtnInside: true,
                callbacks: {
                    open: function () {
                        if (!!this.ev.context.dataset.popupOpenCallback) {      // the popup callback function is specified via the data-popup-open-callback attribute on the click element
                            var mp = $.magnificPopup.instance;
                            var popupItem = mp.currItem.src;
                            window[this.ev.context.dataset.popupOpenCallback](popupItem);
                        }
                    },
                    close: function () {
                        if (!!this.ev.context.dataset.popupCloseCallback) {      // the popup callback function is specified via the data-popup-close-callback attribute on the click element
                            var mp = $.magnificPopup.instance;
                            var popupItem = mp.currItem.src;
                            window[this.ev.context.dataset.popupCloseCallback](popupItem);
                        }
                    },
                }
            });
        });
        initSelects();
    });

    function keyboardUserCheckInElem(event) {		// function to check for a keyboard user navigating to, within or outside a given element
        // check for tab/shift tab (9)
        // check for enter key (13)
        // check for left arrow (37)
        // check for up arrow (38)
        // check for right arrow (39)
        // check for down arrow (40)
        // check for home key (36)
        // check for end key (35)
        var navigatingKeys = [9, 13, 37, 38, 39, 40, 36, 35];
        var activeElemId = document.activeElement;

        if (navigatingKeys.indexOf(event.which) > -1) {
            document.body.classList.add('keyboard-user');
            areasToCheckForKeyboardingArray.forEach(function (id) {
                var elem = document.getElementById(id);
                if (document.hasFocus() && (elem.contains(activeElemId) || elem.isSameNode(activeElemId))) {
                    elem.classList.add('keyboard-user-in-area');
                } else {
                    elem.classList.remove('keyboard-user-in-area');
                }
            });
        }
    }

    document.addEventListener('keyup', keyboardUserCheckInElem);
    document.addEventListener('mousedown', function () {
        document.body.classList.remove('keyboard-user');
        areasToCheckForKeyboardingArray.forEach(function (id) {
            var elem = document.getElementById(id);
            elem.classList.remove('keyboard-user-in-area');
        });
    });
});

function getNextMenuItem(currentItem) {
    let nextItem = currentItem.parentElement.nextElementSibling;
    while (nextItem && nextItem.querySelector('[role="menuitem"]').getAttribute('tabindex') === '-1') {
        nextItem = nextItem.nextElementSibling;
    }
    return nextItem ? nextItem.querySelector('[role="menuitem"]') : currentItem;
}

function getPreviousMenuItem(currentItem) {
    let prevItem = currentItem.parentElement.previousElementSibling;
    while (prevItem && prevItem.querySelector('[role="menuitem"]').getAttribute('tabindex') === '-1') {
        prevItem = prevItem.previousElementSibling;
    }
    return prevItem ? prevItem.querySelector('[role="menuitem"]') : currentItem;
}

function openSubMenu(item) {
    const submenu = item.nextElementSibling;
    if (submenu && submenu.classList.contains('submenu')) {
        item.setAttribute('aria-expanded', 'true');
        // Make submenu items focusable
        const submenuItems = submenu.querySelectorAll('[role="menuitem"]');
        submenuItems.forEach(subItem => subItem.tabIndex = 0);
        submenu.setAttribute('aria-hidden', 'false');
        submenu.style.display = ''; // Clear any inline styles
        submenuItems[0].focus(); // Focus the first submenu item
    }
}

function closeSubMenu(item) {
    const submenu = item.nextElementSibling;
    if (submenu && submenu.classList.contains('submenu')) {
        item.setAttribute('aria-expanded', 'false');
        // Make submenu items unfocusable
        const submenuItems = submenu.querySelectorAll('[role="menuitem"]');
        submenuItems.forEach(subItem => subItem.tabIndex = -1);
        submenu.setAttribute('aria-hidden', 'true');
        submenu.style.display = ''; // Clear any inline styles
    }
}

function addMenuItemEventListener(item) {
    item.addEventListener('keydown', function (e) {
        const currentItem = e.currentTarget;
        let nextItem;
        switch (e.key) {
            case 'ArrowDown':
                e.preventDefault();
                nextItem = getNextMenuItem(currentItem);
                nextItem.focus();
                break;
            case 'ArrowUp':
                e.preventDefault();
                nextItem = getPreviousMenuItem(currentItem);
                nextItem.focus();
                break;
            case 'ArrowRight':
                if (currentItem.getAttribute('aria-haspopup') === 'true') {
                    e.preventDefault();
                    openSubMenu(currentItem);
                }
                break;
            case 'ArrowLeft':
                if (currentItem.parentElement.parentElement.classList.contains('submenu')) {
                    e.preventDefault();
                    const parentItem = currentItem.closest('.submenu').parentElement.querySelector('[role="menuitem"]');
                    closeSubMenu(parentItem);
                    parentItem.focus();
                }
                break;
            case 'Enter':
            case ' ':
                e.preventDefault();
                window.location.href = currentItem.getAttribute('href');
                break;
            case 'Escape':
                if (currentItem.parentElement.parentElement.classList.contains('submenu')) {
                    e.preventDefault();
                    const parentItem = currentItem.closest('.submenu').parentElement.querySelector('[role="menuitem"]');
                    closeSubMenu(parentItem);
                    parentItem.focus();
                }
                break;
            default:
                break;
        }
    });
}

function distanceCalc(lat1, lat2, lon1, lon2) {
    var R = 3959; // miles
    var dLat = (lat2 - lat1) * Math.PI / 180;  // deg2rad below
    var dLon = (lon2 - lon1) * Math.PI / 180;
    var a = 0.5 - Math.cos(dLat) / 2 +
        Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
        (1 - Math.cos(dLon)) / 2;
    return R * 2 * Math.asin(Math.sqrt(a));
}

function roundToOne(num) {
    return +(Math.round(num + 'e+1') + 'e-1');
}

function make2Digits(num) {
    if (num == 0) {
        return '00';
    } else if (num < 10) {
        return '0' + num.toString();
    } else {
        return num.toString();
    }
}

function positionViewAllFloorplanLink() {       			// position the View All Floorplans link taking into account # of slides displayed and whether dots are being shown
    $('#viewAllFloorplansLinkWrapper').width($('#floorplanScroller').width());
    if ($('.floorplanScroller .slick-slide:not(.slick-cloned)').length === 1) {
        $('.viewAllFloorplansLinkWrapper').addClass('single-slide-scroller');                               // single slide.  add class to center the view all floorplan text link
    }
    setTimeout(function () {
        ($('.floorplanScroller .slick-dots:visible').length) ? $('#floorplansSlider').addClass('slick-dotted') : $('#floorplansSlider').removeClass('slick-dotted');
    }, 100);
}

function initBanner() {
    if (document.body.classList.contains('banner') && typeof stickyFooter === 'function') {
        stickyFooter();
    }
}

function isEdge() {
    return /Edge/.test(navigator.userAgent);
}

function isIE() {
    // Simple check for IE per https://stackoverflow.com/a/21712356/1650282
    return window.document.documentMode;
}

function moveAmenitySectionDivs(amenitySectionLabels, hasMap) {
    if (!hasMap) {
        amenitySectionLabels.splice(amenitySectionLabels.indexOf('CommunityMap'), 1);
    }
    var section = 1;
    amenitySectionLabels.forEach(function (label) {
        var target = document.querySelector('.communityDetails' + label);
        if (target) {//pets section may not be present on the page.
            var destination = document.querySelector('#section-' + section++);
            destination.appendChild(target);
            destination.id = 'section-' + label;
        }
    });
    while (section < 7) {//hide unused sections
        var divToHide = document.getElementById('section-' + section);
        if (divToHide) {
            divToHide.style.display = 'none';
        }
        section++;
    }
    if (amenitySectionLabels[0] === 'CommunityMap') {
        $('.detailsListing').addClass('detailsMapFirst');
    } else if (amenitySectionLabels[amenitySectionLabels.length - 1] === 'CommunityMap') {
        $('.detailsListing').addClass('detailsMapLast');
    }
}

function validDateMMDDYYYY(dateInput, checkIfPastDate) {
    const inputDateString = dateInput.val();
    if (dateInput.hasClass('required') && inputDateString.length === 0) {
        $('#' + dateInput.attr('id') + 'ErrorMessage').html('Please Enter a Date');
        return false;
    }
    $('#' + dateInput.attr('id') + 'ErrorMessage').html('Date format is incorrect (MM/DD/YYYY)');
    if (inputDateString.length !== 0) {
        let validDate = $.trim(inputDateString);
        let validDateParts = validDate.split('/');
        if (validDateParts.length !== 3 || validDateParts[0].length !== 2 || validDateParts[1].length !== 2 || validDateParts[2].length !== 4) {
            return false;
        }
        let validDateObj = new Date(validDateParts[2], validDateParts[0] - 1, validDateParts[1]);
        if (validDateObj.getMonth() + 1 !== parseInt(validDateParts[0]) || validDateObj.getDate() !== parseInt(validDateParts[1]) || validDateObj.getFullYear() !== parseInt(validDateParts[2])) {
            return false;
        }
        if (checkIfPastDate) {
            let now = new Date();
            today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            if (validDateObj < today) {
                $('#' + dateInput.attr('id') + 'ErrorMessage').html('Date entered is in the past');
                return false;
            }
        }
    }
    return true;
}


function changeCalendarMonth(element, monthChange, datePickerCalendar) {
    var currentCalenderDisplayedMonth = $('#fd-' + datePickerCalendar + ' .date-picker-table th .month-display').text().trim();             // identify the month/year currently displayed by looking at fields updated by the calendar picker
    var currentCalenderDisplayedYear = $('#fd-' + datePickerCalendar + ' .date-picker-table th .year-display').text().trim();
    var currentCursorDate = new Date(currentCalenderDisplayedMonth + '1, ' + currentCalenderDisplayedYear);
    var newCursorDate = new Date(currentCursorDate.setMonth(currentCursorDate.getMonth() + monthChange));
    datePickerController.setCursorDate(datePickerCalendar, newCursorDate);
    event.stopPropagation();
    return false;
}

function getDistanceMatrixResults(start, end, travelMode) {
    return new Promise((resolve, reject) => {
        try {
            const service = new google.maps.DistanceMatrixService();
            service.getDistanceMatrix({
                origins: [start],
                destinations: [end],
                travelMode: travelMode,
            }, resolve);
        } catch (e) {
            reject(e);
        }
    });
}

const LOCAL_STORAGE_KEYS = {
    COMMUTE_ADDRESS: 'rv-commute-address',
    COMMUTE_TRAVEL_MODE: 'rv-commute-travel-mode',
    COMMUTE_CALCULATED_TIME: 'rv-commute-time',
};

const EDIT_ICON_SVG = '<svg viewBox="0 0 492.49284 492" xmlns="http://www.w3.org/2000/svg" class="commute-edit-icon-svg" aria-label="Click to Edit">' +
    '<title>Click to Edit</title>' +
    '<path d="m304.140625 82.472656-270.976563 270.996094c-1.363281 1.367188-2.347656 3.09375-2.816406 4.949219l-30.035156 120.554687c-.898438 3.628906.167969 7.488282 2.816406 10.136719 2.003906 2.003906 4.734375 3.113281 7.527344 3.113281.855469 0 1.730469-.105468 2.582031-.320312l120.554688-30.039063c1.878906-.46875 3.585937-1.449219 4.949219-2.8125l271-270.976562zm0 0"/>' +
    '<path d="m476.875 45.523438-30.164062-30.164063c-20.160157-20.160156-55.296876-20.140625-75.433594 0l-36.949219 36.949219 105.597656 105.597656 36.949219-36.949219c10.070312-10.066406 15.617188-23.464843 15.617188-37.714843s-5.546876-27.648438-15.617188-37.71875zm0 0"/>' +
    '</svg>';

const RIGHT_ARROW_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.91 29.12" aria-label="" class="linkArrow" focusable="false">' +
    '<g data-name="Layer 2"><g data-name="Layer 1">' +
    '<path d="M11.43,14.62.68,25.24C-1.44,27.36,1.88,30.54,4,28.42L16.21,16.21a2.17,2.17,0,0,0,0-3.19L4,.68C1.88-1.44-1.44,1.88.68,3.87Z"></path>' +
    '</g></g></svg>';

const saveCommuteInfo = (address, travelMode, commuteTime) => {
    localStorage.setItem(LOCAL_STORAGE_KEYS.COMMUTE_ADDRESS, address);
    localStorage.setItem(LOCAL_STORAGE_KEYS.COMMUTE_TRAVEL_MODE, travelMode);
    localStorage.setItem(LOCAL_STORAGE_KEYS.COMMUTE_CALCULATED_TIME + '-' + location.host, commuteTime);
};

const getSavedCommuteInfo = () => {
    return {
        address: localStorage.getItem(LOCAL_STORAGE_KEYS.COMMUTE_ADDRESS),
        travelMode: localStorage.getItem(LOCAL_STORAGE_KEYS.COMMUTE_TRAVEL_MODE),
        commuteTime: localStorage.getItem(LOCAL_STORAGE_KEYS.COMMUTE_CALCULATED_TIME + '-' + location.host),
    };
};

const clearCommuteInfo = () => {
    localStorage.removeItem(LOCAL_STORAGE_KEYS.COMMUTE_ADDRESS);
    localStorage.removeItem(LOCAL_STORAGE_KEYS.COMMUTE_TRAVEL_MODE);
    localStorage.removeItem(LOCAL_STORAGE_KEYS.COMMUTE_CALCULATED_TIME + '-' + location.host);
};

const getTravelModeAsLabel = (travelMode) => {
    switch (travelMode) {
        case 'DRIVING':
            return 'Car';
        case 'BICYCLING':
            return 'Bike';
        case 'WALKING':
            return 'Walking';
        case 'TRANSIT':
            return 'Transit';
        default:
            return '';
    }
};

const setupGooglePlacesAutoComplete = (input, communityCountry) => {
    return new google.maps.places.Autocomplete(input, {
        types: ['geocode'],
        componentRestrictions: {country: communityCountry}
    });
};

function commuteCalculatorInit() {
    if (document.getElementById('commute-popup') == null) {//bail if no commute calculator code
        return;
    }

    const seeCommuteBtn = document.querySelector('.see-commute-btn'),
        savedInfo = getSavedCommuteInfo(),
        commuteCalculator = document.getElementById('commute-popup'),
        commuteError = document.getElementById('commute-error'),
        commuteMissingInput = document.getElementById('commute-missing-input'),
        submitBtn = commuteCalculator.querySelector('.commute-calculator-submit'),
        addressInput = commuteCalculator.querySelector('#commute-address'),
        commuteTravelMode = document.getElementById('commute-travel-mode'),
        communityAddress = commuteCalculator.querySelector('#community-address').value,
        communityCountry = commuteCalculator.querySelector('#community-country').value,
        commuteResults = commuteCalculator.querySelector('.commute-results');

    let initialized = false,
        commuteMagnific = null;

    const displayCommuteTimeInButton = (travelMode, travelTime) => {
        if (travelTime !== null) {
            const travelModeSVG = commuteTravelMode.querySelector('input:checked + label svg');
            seeCommuteBtn.innerHTML = travelModeSVG.outerHTML
                + '<span class="hiddenIR">By ' + getTravelModeAsLabel(travelMode) + '</span>'
                + '<span class="commute-travel-time"> ' + travelTime + ' to work</span>'
                + EDIT_ICON_SVG;
            seeCommuteBtn.classList.add('has-commute');
        } else { // If no travelTime was given, Reset to "See Commute >" text.
            seeCommuteBtn.innerHTML = 'See Commute<span class="commuteArrowWrapper">' + RIGHT_ARROW_SVG + '</span>';
            seeCommuteBtn.classList.remove('has-commute');
        }
    };

    const displayCommuteError = (errorMessage) => {
        commuteError.innerText = errorMessage;
        $(commuteError).show();
        $(addressInput).addClass('inputError');
        $(addressInput).focus();
    };

    const showTravelTimeResult = (travelMode, travelTime) => {
        const travelModeSVG = commuteTravelMode.querySelector('input:checked + label svg');
        commuteResults.innerHTML = ('<li class="commute-result-item">' + travelModeSVG.outerHTML + '<b>By ' + getTravelModeAsLabel(travelMode) + '</b><span class="commute-travel-time"> ' + travelTime + '</span></li>');
    };

    const calculateCommute = () => {
        trackEngagedAction(1);
        $(commuteError).hide();
        $(addressInput).removeClass('inputError');
        submitBtn.disabled = true;
        commuteResults.innerHTML = '';

        const address = addressInput.value,
            travelMode = commuteTravelMode.querySelector('input[type="radio"]:checked').value;

        if (address && address.trim().length) {
            let travelTime = null;
            let didError = false;
            getDistanceMatrixResults(communityAddress, address, travelMode)
                .then((response) => {
                    if (response && response.rows.length) {
                        const result = response.rows[0];

                        if (result.elements.length) {
                            if (result.elements[0].status === 'OK') {
                                //We only ever search one address at a time and should only get one result.
                                travelTime = result.elements[0].duration.text;
                                //Add new result to the dom.
                                showTravelTimeResult(travelMode, travelTime);
                            } else if (result.elements[0].status === 'NOT_FOUND') {
                                //Typically this means Google couldn't find the provided address.
                                displayCommuteError('Address could not be found.');
                                didError = true;
                            } else if (result.elements[0].status === 'ZERO_RESULTS') {
                                //Typically this means Google couldn't find a route due to transportation/route limitations.
                                showTravelTimeResult(travelMode, 'Not Available');
                                didError = true;
                            } else {
                                //TODO log this to Sentry?
                                console.error(response);
                                displayCommuteError('Unable to calculate commute.');
                                didError = true;
                            }
                        }
                    }
                }).catch((e) => {
                //TODO log this to Sentry?
                console.error(e);
                displayCommuteError('Unable to calculate commute.');
                didError = true;
            }).finally(() => {
                // If an error occurred reset commute calculator
                didError ? clearCommuteInfo() : saveCommuteInfo(address, travelMode, travelTime);
                displayCommuteTimeInButton(travelMode, travelTime);
                submitBtn.disabled = false;
            });
        } else {
            displayCommuteError('Please enter an address.');
            displayCommuteTimeInButton(travelMode, null); // pass a null travelTime to clear text.
            clearCommuteInfo();
            submitBtn.disabled = false;
        }
    };

    if (savedInfo.address) {
        addressInput.value = savedInfo.address;
    }

    if (savedInfo.travelMode) {
        commuteTravelMode.querySelectorAll('input[type="radio"]').forEach((travelMode) => {
            travelMode.nextElementSibling.classList.remove('active');
            if (travelMode.value === savedInfo.travelMode) {
                travelMode.checked = true;
                travelMode.nextElementSibling.classList.add('active');
            } else {
                travelMode.checked = false;
            }
        });
    }

    if (savedInfo.commuteTime && savedInfo.commuteTime != 'null') {
        displayCommuteTimeInButton(savedInfo.travelMode, savedInfo.commuteTime);
        showTravelTimeResult(savedInfo.travelMode, savedInfo.commuteTime);
    }

    const setupEventListeners = () => {
        const addressAutoComplete = setupGooglePlacesAutoComplete(addressInput, communityCountry);
        google.maps.event.addListener(addressAutoComplete, 'place_changed', calculateCommute);

        const $allTravelModeLabels = $(commuteTravelMode).find('.commute-travel-mode-label');
        commuteTravelMode.querySelectorAll('input[type="radio"]').forEach(travelMode => {
            const travelModeLabel = travelMode.nextElementSibling;

            travelMode.addEventListener('change', (evt) => {
                $allTravelModeLabels.removeClass('active');
                travelModeLabel.classList.add('active');
                calculateCommute();
            });
        });

        submitBtn.addEventListener('click', () => {
            $.magnificPopup.close();
        });
    };

    const initializePopup = () => {
        if (typeof google !== 'object' || typeof google.maps !== 'object') {
            const mapLoaderSrc = commuteCalculator.dataset.mapLoader,
                mapScript = document.createElement('script');

            mapScript.setAttribute('src', mapLoaderSrc);
            mapScript.setAttribute('type', 'text/javascript');
            mapScript.onload = setupEventListeners;

            commuteCalculator.appendChild(mapScript);
        } else {
            setupEventListeners();
        }

        initialized = true;
    };

    if (seeCommuteBtn) {
        commuteMagnific = $(seeCommuteBtn).magnificPopup({
            items: {
                src: '#commute-popup',
                type: 'inline'
            },
            type: 'inline',
            midClick: true,
            closeBtnInside: true,
            callbacks: {
                open: () => {
                    if (!initialized) {
                        initializePopup();
                    }
                },
                close: () => {
                    $(commuteError).hide();
                    $(addressInput).removeClass('inputError');
                }
            }
        });
    }
}

window.addEventListener('load', function () {

    function afterRedrawFunction(objFromDatePicker) {
        var $calendarContainer = $('#' + objFromDatePicker.id + 'PickerContainer');    // identify the container of the calendar that was just redrawn
        if ($calendarContainer.find('.date-picker-table .prev-month').hasClass('fd-disabled')) {                                               // if the datepicker calendar has disabled the prev and next month buttons, then we need to do the same with our custom prev and next buttons
            $calendarContainer.find('.custom-calendar-header .prev-month-container .month-button').prop('disabled', true).addClass('disabled');
        } else {
            $calendarContainer.find('.custom-calendar-header .prev-month-container .month-button').prop('disabled', false).removeClass('disabled');
        }
        if ($calendarContainer.find('.date-picker-table .next-month').hasClass('fd-disabled')) {
            $calendarContainer.find('.custom-calendar-header .next-month-container .month-button').prop('disabled', true).addClass('disabled');
        } else {
            $calendarContainer.find('.custom-calendar-header .next-month-container .month-button').prop('disabled', false).removeClass('disabled');
        }
    }

    if (typeof datePickerController != 'undefined') {											// only loading this library when we know a datepicker is going to be used
        const inputDatePickers = document.getElementsByClassName('add-date-picker');
        for (let inputElement of inputDatePickers) {
            let inputElementId = inputElement.id;
            let $inputElement = $(inputElement);
            let allowPastDates = false;
            if ($inputElement.hasClass('allow-past-dates')) {
                allowPastDates = true;
            }

            function toggleDatePicker(event, inputElementId) {
                let datePickerContainerId = '#' + inputElementId + 'PickerContainer';
                let $datePickerContainer = $(datePickerContainerId);
                if ($datePickerContainer.hasClass('hidden')) {
                    if ($('#' + inputElementId).val()) {
                        $datePickerContainer.find('.date-picker-label').html($('#' + inputElementId).attr('placeholder'));
                    } else {
                        $datePickerContainer.find('.date-picker-label').html('');
                    }
                    $datePickerContainer.show().removeClass('hidden');
                    $datePickerContainer.find(' .month-button:not(.disabled)').focus();
                    document.addEventListener('click', closeDatePickerWhenOutside, true);
                } else {
                    $datePickerContainer.hide().addClass('hidden');
                    document.removeEventListener('click', closeDatePickerWhenOutside, true);
                }
                event.preventDefault();
                return false;
            }

            function closeDatePickerWhenOutside(event) {					// close all datepickers that may be open, when clicked outside that datepickers activation button or datepicker

                let $datePickerContainer = $inputElement.parent().find('.date-picker-container:not(.hidden)');
                if ($datePickerContainer.length > 0) {
                    let $calendarButton = $inputElement.parent().find('.calendar-icon-button');
                    setTimeout(function () {
                        let target = event.target;
                        if ((event.type == 'blur') || (event.type == 'focusout')) {				//this covers navigating to outside the calendar via keyboard
                            target = document.activeElement;
                        }
                        if (!($datePickerContainer[0].contains(target)		// inside datepicker
                            || $datePickerContainer[0].isSameNode(target)	// on the datepicker
                            || $calendarButton[0].isSameNode(target)		// on the calendar icon button
                            || $calendarButton[0].contains(target)			// inside the calendar icon button
                            || (target === document.body)					// not on a specific element
                            || target.classList.contains('mfp-wrap')))		// a popup, but not on a specific element
                        {
                            $datePickerContainer.hide().addClass('hidden');
                            document.removeEventListener('click', closeDatePickerWhenOutside, true);
                        }
                        event.preventDefault();
                        return false;
                    }, 50);
                }
            }

            let wrapperDivId = inputElementId + 'Wrapper';
            let calendarIconButtonId = inputElementId + 'CalendarIconButton';
            let datePickerContainerId = inputElementId + 'PickerContainer';
            let datePickerLabelId = inputElementId + 'Label';
            let inputElementPlaceholder = $inputElement.attr('placeholder');

            let wrapperDiv = `<div class="input-date-picker-wrapper" id=${wrapperDivId} >`;
            $inputElement.wrap(wrapperDiv);
            let $wrapper = $('#' + wrapperDivId);

            let datePickerLabel = `<label for=${inputElementId} id=${datePickerLabelId} class="formQuestionLabel" style="">${inputElementPlaceholder}</label>`;
            $wrapper.append(datePickerLabel);
            let calendarIconButton = `<button id=${calendarIconButtonId} class="calendar-icon-button" aria-label="Date Picker"><div class="calendar-icon-svg-center"></div></button>`;
            $wrapper.append(calendarIconButton);

            let datePickerContainer =
                `<div id=${datePickerContainerId} class="date-picker-container hidden" style="display: none;">` +
                `<label class="date-picker-label" >${inputElementPlaceholder}</label>` +
                `<div class="custom-calendar-header">` +
                `<div class="custom-calendar-header-center">` +
                `<div class="prev-month-container">` +
                `<button class="month-button" title="Previous" onclick="event.preventDefault(); changeCalendarMonth(this, -1, '${inputElementId}');">` +
                `<svg class="arrow-triangle left-arrow-triangle" xmlns="http://www.w3.org/2000/svg" width="9" height="13.693" viewBox="0 0 9 13.693" aria-label="Scroll Left" focusable="false">` +
                `<title>Previous</title>` +
                `<path d="M6.847,0l6.847,9H0Z" transform="translate(0 13.693) rotate(-90)"></path>` +
                `</svg>` +
                `</button>` +
                `</div>` +
                `<div class="next-month-container">` +
                `<button class="month-button" title="Next" onclick="event.preventDefault(); changeCalendarMonth(this, +1, '${inputElementId}');">` +
                `<svg class="arrow-triangle right-arrow-triangle" xmlns="http://www.w3.org/2000/svg" width="9" height="13.693" viewBox="0 0 9 13.693" aria-label="Scroll Right" focusable="false">` +
                `<title>Next</title>` +
                `<path d="M6.847,0l6.847,9H0Z" transform="translate(9) rotate(90)"></path>` +
                `</svg>` +
                `</button>` +
                `</div>` +
                `</div>` +
                `</div>` +
                `</div>`;
            $wrapper.append(datePickerContainer);

            let calendarIconButtonElement = document.getElementById(calendarIconButtonId);
            calendarIconButtonElement.addEventListener('click', (event) => {
                toggleDatePicker(event, inputElementId);
            });
            calendarIconButtonElement.addEventListener('focusout', closeDatePickerWhenOutside, true);
            document.getElementById(datePickerContainerId).addEventListener('focusout', closeDatePickerWhenOutside, true);

            datePickerController.createDatePicker({
                formElements: {
                    [inputElementId]: '%m/%d/%Y'
                },
                staticPos: true,
                rangeLow: allowPastDates ? null : new Date(),
                positioned: datePickerContainerId,
                callbackFunctions: {
                    'redraw': [afterRedrawFunction],
                }
            });
        }
    }

    commuteCalculatorInit();
});

const SESSION_STORAGE_PAGE_COUNT = 'rv-valid-page-count';
const SESSION_STORAGE_LAST_VALID_PAGE = 'rv-last-valid-page';
const SESSION_STORAGE_FIRST_VALID_TIME = 'rv-first-valid-time';
const SESSION_STORAGE_LAST_VALID_TIME = 'rv-last-valid-time';
const SESSION_STORAGE_HAS_TRACKED_EV = 'rv-has-ev';
const INVALID_PAGES = ['/privacyPolicy', '/accessibilityStatement', '/termsOfUse', '/residents'];
const HEV_A_PAGES = ['/floorplans', '/amenities', '/floorplan'];

function trackPage() {
    if (INVALID_PAGES.includes(window.location.pathname)) {
        return;
    }
    if (sessionStorage.getItem(SESSION_STORAGE_LAST_VALID_PAGE) === window.location.pathname) {
        return;
    }
    let validPageCount = !!sessionStorage.getItem(SESSION_STORAGE_PAGE_COUNT) ? sessionStorage.getItem(SESSION_STORAGE_PAGE_COUNT) : 0;
    const now = Date.now();
    const firstValidTime = !!sessionStorage.getItem(SESSION_STORAGE_FIRST_VALID_TIME) ? sessionStorage.getItem(SESSION_STORAGE_FIRST_VALID_TIME) : now;
    const lastValidTime = !!sessionStorage.getItem(SESSION_STORAGE_LAST_VALID_TIME) ? sessionStorage.getItem(SESSION_STORAGE_LAST_VALID_TIME) : now;
    let hasTrackedEV = sessionStorage.getItem(SESSION_STORAGE_HAS_TRACKED_EV) === 'true';
    const oneHour = 60 * 60 * 1000;
    const twoSeconds = 2 * 1000;
    if ((now - lastValidTime) > oneHour) {//reset after 1 hour
        validPageCount = 0;
    }
    validPageCount++;
    if (validPageCount >= 2 && !hasTrackedEV && (now - firstValidTime) >= twoSeconds) {
        trackEvent('engaged_visit', window.location.pathname, sessionStorage.getItem(SESSION_STORAGE_LAST_VALID_PAGE));
        hasTrackedEV = true;
    }
    sessionStorage.setItem(SESSION_STORAGE_PAGE_COUNT, validPageCount);
    sessionStorage.setItem(SESSION_STORAGE_FIRST_VALID_TIME, firstValidTime);
    sessionStorage.setItem(SESSION_STORAGE_LAST_VALID_PAGE, window.location.pathname);
    sessionStorage.setItem(SESSION_STORAGE_LAST_VALID_TIME, now);
    sessionStorage.setItem(SESSION_STORAGE_HAS_TRACKED_EV, hasTrackedEV.toString());
    const sanitizedPathname = window.location.pathname.lastIndexOf('/') > 1 ? window.location.pathname.substring(0, window.location.pathname.lastIndexOf('/')) : window.location.pathname;
    if (HEV_A_PAGES.includes(sanitizedPathname)) {
        trackEngagedAction(1);
    }
}

const SESSION_STORAGE_HEV_A_COUNT = 'rv-valid-hev-a-count';
const SESSION_STORAGE_HEV_B_COUNT = 'rv-valid-hev-b-count';
const SESSION_STORAGE_HEV_FIRST_PAGE = 'rv-hev-first-page';
const SESSION_STORAGE_HAS_TRACKED_HEV = 'rv-has-hev';

function trackEngagedAction(type = 1) {
    let validHighlyEngagedVisitACount = sessionStorage.getItem(SESSION_STORAGE_HEV_A_COUNT) ?? 0;
    let validHighlyEngagedVisitBCount = sessionStorage.getItem(SESSION_STORAGE_HEV_B_COUNT) ?? 0;
    const now = Date.now();
    const firstValidTime = !!sessionStorage.getItem(SESSION_STORAGE_FIRST_VALID_TIME) ? sessionStorage.getItem(SESSION_STORAGE_FIRST_VALID_TIME) : now;
    const lastValidTime = sessionStorage.getItem(SESSION_STORAGE_LAST_VALID_TIME) ?? now;
    let hasTrackedHEV = sessionStorage.getItem(SESSION_STORAGE_HAS_TRACKED_HEV) === 'true';
    const oneHour = 60 * 60 * 1000;
    const twoSeconds = 2 * 1000;
    if ((now - lastValidTime) > oneHour) {//reset after 1 hour
        validHighlyEngagedVisitACount = 0;
        validHighlyEngagedVisitBCount = 0;
    }
    if (validHighlyEngagedVisitACount + validHighlyEngagedVisitBCount === 0) {
        sessionStorage.setItem(SESSION_STORAGE_HEV_FIRST_PAGE, window.location.pathname);
    }
    if (type === 1) {
        validHighlyEngagedVisitACount++;
    } else if (type === 2) {
        validHighlyEngagedVisitBCount++;
    }
    //need 2+ of A and 1+ of B
    const crossedHighlyEngagedVisitThreshold = validHighlyEngagedVisitACount >= 2 && validHighlyEngagedVisitBCount >= 1;
    if (crossedHighlyEngagedVisitThreshold && !hasTrackedHEV && (now - firstValidTime) >= twoSeconds) {
        trackEvent('highly_engaged_visit', window.location.pathname, sessionStorage.getItem(SESSION_STORAGE_HEV_FIRST_PAGE));
        hasTrackedHEV = true;
    }
    sessionStorage.setItem(SESSION_STORAGE_FIRST_VALID_TIME, firstValidTime);
    sessionStorage.setItem(SESSION_STORAGE_HEV_A_COUNT, validHighlyEngagedVisitACount);
    sessionStorage.setItem(SESSION_STORAGE_HEV_B_COUNT, validHighlyEngagedVisitBCount);
    sessionStorage.setItem(SESSION_STORAGE_LAST_VALID_TIME, now);
    sessionStorage.setItem(SESSION_STORAGE_HAS_TRACKED_HEV, hasTrackedHEV.toString());
}